import PropTypes from 'prop-types'
import { forwardRef, useId, useState } from 'react'
import TextareaAutosize from 'react-textarea-autosize'

import { isPresent } from 'utils'

import Text from 'components/Text'

import { Input, Label, Root } from './TextInput.style'

const TextInput = forwardRef(({ label, multiline, error, onChange: onChangeProp, ...props }, ref) => {
  const [_value, _setValue] = useState(props.value)
  const id = useId()

  const onChange = (e) => {
    const {
      target: { value },
    } = e
    onChangeProp?.(e)
    _setValue(value)
  }

  return (
    <div>
      <Root $error={error}>
        <Label htmlFor={id} $inputPresent={isPresent(_value)} $error={error}>
          <Text>{label}</Text>
        </Label>
        <Input
          id={id}
          ref={ref}
          type="text"
          as={multiline ? TextareaAutosize : 'input'}
          {...props}
          onChange={onChange}
        />
      </Root>
    </div>
  )
})

TextInput.propTypes = {
  label: PropTypes.string.isRequired,
  multiline: PropTypes.bool,
  error: PropTypes.any,
  onChange: PropTypes.func,
}

TextInput.defaultProps = {
  multiline: false,
}

TextInput.displayName = 'TextInput'

export default TextInput
